import {
  FETCH_SAVED_CANDIDATES_REQUEST,
  FETCH_SAVED_CANDIDATES_SUCCESS,
  FETCH_SAVED_CANDIDATES_FAILURE,
  RESET_SAVED_CANDIDATES,
  DELETE_SAVED_CANDIDATE_REQUEST,
  DELETE_SAVED_CANDIDATE_SUCCESS,
  DELETE_SAVED_CANDIDATE_FAILURE,
} from "../../actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  message: "",
  status: false,
};

const fetchSavedCandidatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SAVED_CANDIDATES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_SAVED_CANDIDATES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: action.payload.status,
        isLoading: false,
      };
    case FETCH_SAVED_CANDIDATES_FAILURE:
      return {
        ...state,
        message: action.payload.message,
        status: action.payload.status,
        isLoading: false,
      };
    case DELETE_SAVED_CANDIDATE_REQUEST:
      return { ...state, isLoading: true };
    case DELETE_SAVED_CANDIDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case DELETE_SAVED_CANDIDATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case RESET_SAVED_CANDIDATES:
      return {
        ...state,
        isLoading: false,
        status: false,
        message: "",
      };
    default:
      return state;
  }
};
export default fetchSavedCandidatesReducer;
